import React from 'react';
import { Button } from 'react-toolbox/lib/button';
import { FontIcon } from 'react-toolbox/lib/font_icon';
import styles from './StepPanelButtonBar.css';
import nextButtonTheme from './StepPanelButtonBarNextButtonTheme.css';

const StepPanelButtonBar = ({ onCancel, onNext, onSubmit }) =>
  <div className={styles.container}>
    {onNext &&
      <Button theme={nextButtonTheme} onClick={onNext}>
        Continue
        <FontIcon style={{ marginRight: -8 }} value="arrow_forward" />
      </Button>}

    {onSubmit &&
      <Button theme={nextButtonTheme} onClick={onSubmit}>
        Submit
      </Button>}

    <Button
      className={styles.cancelButton}
      label="Start Over"
      onClick={onCancel}
    />
  </div>;

export default StepPanelButtonBar;



// WEBPACK FOOTER //
// ./src/general-components/StepPanelButtonBar.js